import { NumberInput, NumberInputStylesNames } from '@mantine/core';
import { KeyboardEvent, useRef } from 'react';

type PercentageInputProps = {
  value: string | number;
  onChange: (value: string | number) => void;
  onBlur?: () => void;
  classNames?: Partial<Record<NumberInputStylesNames, string>>;
};

export function PercentageInput(props: PercentageInputProps) {
  const { value, onChange, onBlur, classNames } = props;
  const ref = useRef<HTMLInputElement | null>(null);

  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      ref.current?.blur();
    }
  };

  return (
    <NumberInput
      classNames={classNames}
      ref={ref}
      suffix="%"
      value={value}
      onChange={onChange}
      hideControls
      min={0}
      max={100}
      clampBehavior="strict"
      allowNegative={false}
      allowLeadingZeros={false}
      allowDecimal={false}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
    />
  );
}
